import MuiIconButton from '@mui/material/IconButton';
import type { ComponentProps } from 'react';

type Props = Pick<
  ComponentProps<typeof MuiIconButton>,
  'title' | 'onClick' | 'children' | 'className' | 'disabled'
>;

export const IconButton = (props: Props & { style?: object }) => {
  return <MuiIconButton {...props} />;
};
